function shouldUseFunctionsEmulator() {
  return (
    process.env.NODE_ENV === "development" &&
    process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === "true"
  );
}

function getFunctionsEmulatorApiBaseUrl() {
  const host = process.env.REACT_APP_FUNCTIONS_EMULATOR_HOST || "127.0.0.1";
  const port = process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || "5001";
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || "talmids";
  const region = process.env.REACT_APP_FUNCTIONS_REGION || "us-central1";

  return `http://${host}:${port}/${projectId}/${region}/api`;
}

export function getFunctionsApiBaseUrl() {
  if (shouldUseFunctionsEmulator()) {
    return getFunctionsEmulatorApiBaseUrl();
  }

  const fromEnv = process.env.REACT_APP_FUNCTIONS_API_URL;
  if (fromEnv && fromEnv.trim()) {
    return fromEnv.trim().replace(/\/+$/, "");
  }

  if (typeof window !== "undefined") {
    return `${window.location.origin}/api`;
  }

  return "/api";
}
